import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import { useDevice } from './useDevice.js';

const Device = ({ children, type: deviceType }) => {
    const { type } = useDevice();
    if (type === deviceType) {
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: children });
    }
    return null;
};

export { Device };
//# sourceMappingURL=Device.js.map
